import styled from 'styled-components';

export const Content = styled.div`
  form {
    margin: 0;
    padding: 0 0 5px;
  }
`;

export const Header = styled.p`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 30px;
  text-align: center;
`;

export const Info = styled.label`
  font-size: 15px;
  display: block;
  cursor: pointer;
  font-weight: normal;
  margin-bottom: 10px;
  select {
    margin-left: 0.5rem;
  }
`;
